import React from "react";

import { Redirect, Route, RouteComponentProps } from "react-router-dom";

import { ProsumerMontioringCredentials } from "./ProsumerMonitoringCredentials";
import { ProsumerBillingCredentials } from "./ProsumerBillingCredentials";
import { GreenEnergyOffers } from "./GreenEnergyOffers";
import { ContractForm } from "./ContractForm";
import { ContractDetails } from "./ContractDetails";

import Start from "./Start";
import MonitoringWaitScreen from "./MonitoringWaitList";
import MonitoringSkip from "./MonitoringSkip";
// import EnergyOperator from "./EnergyOperator";
import EnergyOperatorSkip from "./EnergyOperatorSkip";
import { EnergyWaitlist } from "./EnergyWaitlist";
// import MonitoringScreen from "./Monitoring";
import PendingScreen from "./Pending";
import { ConsumerBillUpload } from "./ConsumerBillUpload";
import { BuildingType } from "./BuildingType";
import { EnergyCost } from "./EnergyCost";
import { DeviceRegistry } from "./DeviceRegistry";
import { RoomWifiStatus } from "./RoomWifiStatus";
import { ElectricalCapacity } from "./ElectricalCapacity";
import { GreenEnergyStatus } from "./GreenEnergyStatus";
import { BuildingAvatar } from "./BuildingAvatar";
import { BuildingTension } from "./BuildingTension";
import { BuildingBasics } from "./BuildingBasics";
import { BuildinghasFV } from "./BuildinghasFV";

import ProsumerWaitlist from "./ProsumerWaitlist";

import { NoInvoicesCredentials } from "./NoInvoicesCredentials";
import { OfferDetail } from "./OfferDetail";
import { NoMonitoringCredentials } from "./NoMonitoringCredentials";

export const OnBoardingRouter = ({ match: { path } }: RouteComponentProps) => {
  return (
    <>
      <Route
        exact
        path={`${path}/prosumer-monitoring-credentials`}
        component={ProsumerMontioringCredentials}
      />
      <Route
        exact
        path={`${path}/prosumer-billing-credentials`}
        component={ProsumerBillingCredentials}
      />
      <Route
        exact
        path={`${path}/consumer-bill-upload`}
        component={ConsumerBillUpload}
      />
      <Route
        exact
        path={`${path}/green-energy-offers`}
        component={GreenEnergyOffers}
      />
      <Route exact path={`${path}/offer-detail`} component={OfferDetail} />
      <Route exact path={`${path}/contract-form`} component={ContractForm} />
      <Route
        exact
        path={`${path}/contract-details`}
        component={ContractDetails}
      />
      <Route exact path={`${path}/building-type`} component={BuildingType} />
      <Route exact path={`${path}/energy-cost`} component={EnergyCost} />
      <Route
        exact
        path={`${path}/device-registry`}
        component={DeviceRegistry}
      />
      <Route
        exact
        path={`${path}/room-wifi-status`}
        component={RoomWifiStatus}
      />
      <Route
        exact
        path={`${path}/electrical-capacity`}
        component={ElectricalCapacity}
      />
      <Route
        exact
        path={`${path}/building-tension`}
        component={BuildingTension}
      />
      <Route
        exact
        path={`${path}/green-energy-status`}
        component={GreenEnergyStatus}
      />
      <Route
        exact
        path={`${path}/building-avatar`}
        component={BuildingAvatar}
      />
      <Route
        exact
        path={`${path}/building-basics`}
        component={BuildingBasics}
      />
      <Route
        exact
        path={`${path}/no-monitoring-credentials`}
        component={NoMonitoringCredentials}
      />
      <Route exact path={`${path}/building-has-fv`} component={BuildinghasFV} />

      <Route
        exact
        path={`${path}/no-invoices-credentials`}
        component={NoInvoicesCredentials}
      />
      <Route path={`${path}/prosumer-waitlist`} component={ProsumerWaitlist} />

      <Route exact path={`${path}/`} component={Start} />
      <Route path={`${path}/energy-operator`}>
        <Redirect to={`${path}/prosumer-billing-credentials`} />
      </Route>
      <Route path={`${path}/energy-waitlist`} component={EnergyWaitlist} />
      <Route
        path={`${path}/energy-operator-skip`}
        component={EnergyOperatorSkip}
      />
      <Route path={`${path}/pending`} component={PendingScreen} />
      <Route path={`${path}/monitoring`}>
        <Redirect to={`${path}/prosumer-monitoring-credentials`} />
      </Route>

      <Route
        path={`${path}/monitoring-waitlist`}
        component={MonitoringWaitScreen}
      />
      <Route path={`${path}/monitoring-skip`} component={MonitoringSkip} />
    </>
  );
};
